import request from '@/request/request'
const baseURL = global.$config.api.jkUrl
// 获取停车场列表
export function getList(data) {
    return request({
        url: '/api/data-server/data/entityBaseAllInfo/findPage',
        method: 'post',
        data: data,
    })
}

// export function getDetail(data) {
//     return request({
//         url: '/entityBaseAllInfo/findOne',
//         method: 'post',
//         data: data,
//         baseURL: baseURL,
//     })
// }

// 查看停车场详情
export function getDetail(data) {
    return request({
        url: '/api/data-server/data/entityBaseAllInfo/findOne',
        method: 'post',
        data: data
    })
}

// 停车场保存
export function save(data) {
    return request({
        url: '/api/data-server/data/entityBaseAllInfo/save',
        method: 'post',
        data: data
    })
}

// export function save(data) {
//     return request({
//         url: '/entityBaseAllInfo/save',
//         method: 'post',
//         data: data,
//         baseURL: baseURL,
//     })
// }

// 停车场删除
export function deleteByIds(data) {
    return request({
        url: '/api/data-server/data/entityBaseAllInfo/deleteByIds',
        method: 'post',
        data: data
    })
}

// export function deleteByIds(data) {
//     return request({
//         url: '/entityBaseAllInfo/deleteByIds',
//         method: 'post',
//         data: data,
//         baseURL: baseURL,
//     })
// }

export function CarParkRecordInOut(data) {
    return request({
        url: '/api/analysis/bizParkingOut/findInOutPage',
        method: 'post',
        data: data
    })
}
//华阳客流监控点接口
export function PassengergroupPageInfo(data) {
    return request({
        url: '/api/analysis/staPassengerAnalyse/groupPageInfo',
        method: 'post',
        data: data
    })
}
